<ng-container *ngIf="berth?.id">
    <ng-container *ngIf="disableLink; else withLink">
        <span [attr.data-test]="dataTest">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Liegeplatz kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </span>
    </ng-container>
    <ng-template #withLink>
        <a (click)="click($event)"
           [attr.data-test]="dataTest"
           [bcmRouterLink]="['berths', berth.id]">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Liegeplatz kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </a>
    </ng-template>
</ng-container>
